import React, { useEffect, useState } from 'react'
import { Button, Select, TextInput } from 'components/Form'
import { ConfirmationModal, Modal, SimpleTable, Tooltip } from 'components/Ui'
import { getApiData, deleteApiRecord, createApiRecord, updateApiRecord } from 'services/WarehouseService'
import { Field, Form, Formik } from 'formik'
import { AiOutlinePlus } from 'react-icons/ai'
import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi'
import { Success } from 'utils/alerts'
import * as Yup from 'yup'
import { companyStatus } from 'components/helper'
import { useDispatch } from 'react-redux'
import { getWarehouseData } from 'store/data/dataSlice'

const validationSchema = Yup.object().shape({
    name: Yup.string().required('company name field is required'),
    company: Yup.string().required('company field is required'),
    customer: Yup.string().required('customer field is required'),
    warehouse_code: Yup.string().required('warehouse code field is required'),
})

export default function WarehouseTabView({ companyData, customersData, record }) {
    const [data, setData] = useState([])
    const dispatch = useDispatch()
    const [selectedData, setSelectedData] = useState()
    const [open, setOpen] = useState(false)

    useEffect(() => {
        if (record) {
            getData({ company: record?.company?.id, customer: record?.id })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [record])

    const getData = data => {
        getApiData(data)
            .then(response => {
                if (response.data) {
                    setData(response.data?.results)
                }
            })
            .catch(error => console.log('Error fetching order type data: ', error))
    }

    const handleStatus = (id, data) => {
        updateApiRecord(id, data)
            .then(() => {
                Success('Status Updated Successfully!')
                getData({
                    company: record?.company?.id,
                    customer: record?.id,
                })
            })
            .catch(error => console.log('Error: ', error))
    }

    const handleDelete = id => {
        deleteApiRecord(id)
            .then(() => {
                Success('Deleted Successfully!')
                getData({
                    company: record?.company?.id,
                    customer: record?.id,
                })
                dispatch(getWarehouseData())
            })
            .catch(error => console.log('Error: ', error))
    }

    const handleSubmit = data => {
        if (selectedData?.id) {
            updateApiRecord(selectedData?.id, data)
                .then(() => {
                    getData({ company: record?.company?.id, customer: record?.id })
                    Success('Updated Successfully!')
                    setOpen(false)
                    setSelectedData()
                    dispatch(getWarehouseData())
                })
                .catch(error => console.log('Error: ', error))
        } else {
            createApiRecord(data)
                .then(() => {
                    getData({ company: record?.company?.id, customer: record?.id })
                    Success('Created Successfully!')
                    setOpen(false)
                    setSelectedData()
                    dispatch(getWarehouseData())
                })
                .catch(error => console.log('Error: ', error))
        }
    }

    return (
        <div>
            <div className="flex items-center justify-end mb-4">
                <Button
                    className="text-white border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                    onClick={() => setOpen(true)}
                >
                    <AiOutlinePlus size={20} /> Add New
                </Button>
            </div>
            <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                <SimpleTable>
                    <thead>
                        <SimpleTable.TR>
                            <SimpleTable.TH>Name</SimpleTable.TH>
                            <SimpleTable.TH>Warehouse Code</SimpleTable.TH>
                            <SimpleTable.TH>Company</SimpleTable.TH>
                            <SimpleTable.TH>Customer</SimpleTable.TH>
                            <SimpleTable.TH>Address</SimpleTable.TH>
                            <SimpleTable.TH>Postal Code</SimpleTable.TH>
                            <SimpleTable.TH>Status</SimpleTable.TH>
                            <SimpleTable.TH>Action</SimpleTable.TH>
                        </SimpleTable.TR>
                    </thead>
                    <tbody>
                        {(data || [])?.map((row, index) => (
                            <SimpleTable.TR key={`row-${index}`}>
                                <SimpleTable.TD>{row?.name}</SimpleTable.TD>
                                <SimpleTable.TD>{row?.warehouse_code}</SimpleTable.TD>
                                <SimpleTable.TD>{row.company_code}</SimpleTable.TD>
                                <SimpleTable.TD>{row?.customer_code}</SimpleTable.TD>
                                <SimpleTable.TD>{row?.address_line1}</SimpleTable.TD>
                                <SimpleTable.TD>{row?.postal_code}</SimpleTable.TD>
                                <SimpleTable.TD>
                                    {/* {checkPermission('warehouse', 'edit') ? ( */}
                                    <ConfirmationModal
                                        onConfirm={() => {
                                            handleStatus(row.id, {
                                                ...row,
                                                status: row.status === 'active' ? 'inactive' : 'active',
                                            })
                                        }}
                                    >
                                        {companyStatus(row.status)}
                                    </ConfirmationModal>
                                    {/* ) : (
                                        companyStatus(row.status)
                                    )} */}
                                </SimpleTable.TD>
                                <SimpleTable.TD>
                                    <div className="flex items-center justify-center gap-3">
                                        {/* {checkPermission('order-type', 'edit') ? ( */}
                                        <Tooltip title={'Edit'}>
                                            <span
                                                onClick={() => {
                                                    setSelectedData(row)
                                                    setOpen(true)
                                                }}
                                                className="hover:text-primary"
                                            >
                                                <HiOutlinePencil size={20} />
                                            </span>
                                        </Tooltip>
                                        {/* ) : null} */}
                                        {/* {checkPermission('order-type', 'delete') ? ( */}
                                        <Tooltip title={'Delete'}>
                                            <ConfirmationModal
                                                message={'Are you sure you want to delete this record!'}
                                                onConfirm={() => handleDelete(row.id)}
                                            >
                                                <span className="hover:text-danger">
                                                    <HiOutlineTrash size={20} />
                                                </span>
                                            </ConfirmationModal>
                                        </Tooltip>
                                        {/* ) : null} */}
                                    </div>
                                </SimpleTable.TD>
                            </SimpleTable.TR>
                        ))}
                    </tbody>
                </SimpleTable>
            </div>
            <Modal
                show={open}
                maxWidth="4xl"
                onClose={() => {
                    setOpen(false)
                    setSelectedData()
                }}
            >
                <div className="flex flex-col gap-1 m-3">
                    <h2 className="font-semibold text-black text-title-md">
                        {selectedData ? 'Update Warehouse' : 'Add New Warehouse'}
                    </h2>
                </div>
                <div className="flex flex-col items-center">
                    <div className="w-full bg-white border rounded-sm overflow-auto max-h-150 border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                        <div className="flex flex-col gap-3 p-6">
                            <Formik
                                initialValues={
                                    selectedData
                                        ? selectedData
                                        : {
                                              company: record?.company?.id,
                                              customer: record?.id,
                                              warehouse_code: '',
                                              name: '',
                                              address_line1: '',
                                              city: '',
                                              state: '',
                                              postal_code: '',
                                              country: '',
                                          }
                                }
                                validationSchema={validationSchema}
                                onSubmit={values => {
                                    handleSubmit(values)
                                }}
                            >
                                {({ values, touched, errors }) => (
                                    <Form>
                                        <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-4">
                                            <Field name="company">
                                                {({ field, form }) => (
                                                    <Select
                                                        id="company"
                                                        name="company"
                                                        label="Company"
                                                        placeholder="Company"
                                                        className="md:col-span-2"
                                                        value={values?.company}
                                                        options={companyData}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                        error={touched.company && errors.company}
                                                        message={errors.company}
                                                        disabled
                                                    />
                                                )}
                                            </Field>
                                            <Field name="customer">
                                                {({ field, form }) => (
                                                    <Select
                                                        id="customer"
                                                        name="customer"
                                                        label="Customer"
                                                        placeholder="Customer"
                                                        className="md:col-span-2"
                                                        value={values?.customer}
                                                        options={customersData}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                        error={touched.customer && errors.customer}
                                                        message={errors.customer}
                                                        disabled
                                                    />
                                                )}
                                            </Field>
                                            <Field name="name">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Name"
                                                        name="name"
                                                        error={errors.name && touched.name}
                                                        message={errors.name}
                                                        value={values?.name}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="warehouse_code">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Warehouse Code"
                                                        name="warehouse_code"
                                                        error={errors.warehouse_code && touched.warehouse_code}
                                                        message={errors.warehouse_code}
                                                        value={values?.warehouse_code}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="address_line1">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Address"
                                                        name="address_line1"
                                                        error={errors.address_line1 && touched.address_line1}
                                                        message={errors.address_line1}
                                                        value={values?.address_line1}
                                                        onChange={e => form.setFieldValue(`${field.name}`, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="city">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="City"
                                                        name="city"
                                                        error={errors.city && touched.city}
                                                        message={errors.city}
                                                        value={values?.city}
                                                        onChange={e => form.setFieldValue(`${field.name}`, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="state">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="State"
                                                        name="state"
                                                        error={errors.state && touched.state}
                                                        message={errors.state}
                                                        value={values?.state}
                                                        onChange={e => form.setFieldValue(`${field.name}`, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="postal_code">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Postal Code"
                                                        name="postal_code"
                                                        error={errors.postal_code && touched.postal_code}
                                                        message={errors.postal_code}
                                                        value={values?.postal_code}
                                                        onChange={e => form.setFieldValue(`${field.name}`, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="country">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Country"
                                                        name="country"
                                                        error={errors.country && touched.country}
                                                        message={errors.country}
                                                        value={values?.country}
                                                        onChange={e => form.setFieldValue(`${field.name}`, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                        </div>
                                        <div className="flex items-center justify-end gap-4 mt-3">
                                            <Button
                                                className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                                type="button"
                                                onClick={() => {
                                                    setOpen(false)
                                                    setSelectedData()
                                                }}
                                            >
                                                Discard
                                            </Button>
                                            <Button
                                                type="submit"
                                                className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                            >
                                                Save
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
